import {

  AddOnsApi,
  IdentityMelcoModelsUserAddOns,
  useAPIQuery,
  useTable,
} from "melco-shared-logic";
import { useTableErrorComponent } from "../table/useTableErrorComponent";
import { isEmpty } from "lodash-es";

export const useAddOnSearch = () => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQuery,
    searchQueryChange,
  } = useTable<IdentityMelcoModelsUserAddOns>();

  const query = useAPIQuery(
    AddOnsApi,
    ["addOnSearch", currentPage, pageSize, filters, sortBy(), searchQuery],
    async (api) => {
      let response = await api.addsOnSearch({
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        sortBy: sortBy(),
        searchText: !isEmpty(searchQuery) ? searchQuery : undefined,
      });
      setTotal(response.total);


      console.log("RESPONSE IS ", JSON.stringify(response))

      return response.list;
    },
    {

    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    searchQuery,
    searchQueryChange,
    errorComponent,
    hasSuccessData: Array.isArray(query.data) && query.data.length > 0,

    ...query,
  };
};
